/** ***********
*
* <asset-history.reducer.ts v1.0>
*

* Copyright (c) 2022 AIRBUS OPERATIONS
*
* Contributors:
*  NG6C740 [thomas.pereira.external@airbus.com]
*  ng6c740 [thomas.pereira.external@airbus.com]
*  GARY Adrien (NG635E8) [adrien.gary.external@airbus.com]
*
* All rights reserved.
**************/

import { Action, createReducer, on } from '@ngrx/store';
import { transformArrayIntoMap } from 'src/app/utils/utils';
import { errorAssetHistory, loadAssetHistory, successAssetHistory } from '../actions/asset-history.actions';
import { Event } from 'src/app/models/event';
export interface State {
    data: Event[];
    loading: boolean;
    loaded: boolean;
}

// default state
const INIT_STATE: State = {
    data: [],
    loading: false,
    loaded: false
};

const AssetHistoryReducer = createReducer(
    INIT_STATE,
    on(loadAssetHistory, (state): State => ({
        ...state, loaded: true,
    })),
    on(successAssetHistory, (state, { payload, zones }) => {
        const zoneMap = transformArrayIntoMap(zones, 'id');
        return {
            ...state,
            loading: false,
            loaded: true,
            data: payload.map(event => {
                if (/^in_?use$/.test(event.asset_status)) {
                    event.asset_status = 'inUse';
                }
                event.lastZoneName = event.last_zone?.zone1 ? {
                    zone1: zoneMap[event.last_zone?.zone1]?.name,
                    zone2: zoneMap[event.last_zone?.zone2]?.name,
                    zone3: zoneMap[event.last_zone?.zone3]?.name
                } : undefined;
                return event;
            })
        };
    }),
    on(errorAssetHistory, (state): State => ({
        ...state, loading: false,
    })),
);

export function reducer(state: State | undefined, action: Action) {
    return AssetHistoryReducer(state, action);
}
